const routeMain = () => "/project";

export default routeMain;
